export default "__VITE_ASSET__4310296b__"